module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by Doral Chenoweth Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_c('b', [_vm._v("1. DINERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#ch1-1"
    }
  }, [_vm._v("Circus Chef")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#ch1-2"
    }
  }, [_vm._v("QCB")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#ch1-3"
    }
  }, [_vm._v("Queen Bee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#ch1-4"
    }
  }, [_vm._v("Jack & Benny’s/Benny Klein’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. NEIGHBORHOOD HAUNTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maennerchor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deibel’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reeb’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Presutti’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hennick’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marble Gang Restaurant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerry’s Drive-In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engine House No. 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Place Upstairs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Betty’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. DOWNTOWN FAVORITES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Club at the Hartman Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doersam’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foerster’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("State-Fourth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kuenning’s 19/Kuenning’s Suburban")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paoletti’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Johnson’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Café")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patton’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Nation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. LAVISH DINING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marzetti’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maramor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clarmont")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jai Lai")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tommy Henrich’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L’Armagnac")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handke’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carolyn’s City Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. Themed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jong Mea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water Works")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terrace Room at the Union")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David’s on Main/Out on Main/Brownstone on Main")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. Chains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Gables/Burger Boy Food-O-Rama (BBF)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G.D. Ritzy’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damon’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cantina del Rio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cooker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifty-Five Group")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/reci",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0